module.exports = __webpack_public_path__ + "img/memberReport_consulting.9d28b88c.svg";